import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class Enumsregistry
*  Реестр перечислимых типов  * ключами являются возможные идентификаторы перечислимых типов данных  Идентификатор типа можно найти в схеме типа в свойстве x-dictionary-ref, также он пишется в описании  * значениями словаря являются словари актуальных значений перечисления
*/
export class Enumsregistry extends ActiveModel {

  /**
  * ['Domain.Entities.Notifications.NotificationTemplateType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.NotificationTemplateType']?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.PromotionStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.PromotionStatus']?: Record<string, string>


  /**
  * ['Тип склада']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Тип склада']?: Record<string, string>


  /**
  * ['Domain.Entities.Notifications.NotificationTemplateDeliverySlotType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.NotificationTemplateDeliverySlotType']?: Record<string, string>


  /**
  * RobotsPolicy
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  RobotsPolicy?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.CdekPackageFormationMode']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.CdekPackageFormationMode']?: Record<string, string>


  /**
  * ['Domain.Entities.Notifications.ExchangeNotificationReason']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.ExchangeNotificationReason']?: Record<string, string>


  /**
  * AttributeRequirementsType
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  AttributeRequirementsType?: Record<string, string>


  /**
  * ['Domain.Entities.Exchange.ExchangePriceOwnership']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Exchange.ExchangePriceOwnership']?: Record<string, string>


  /**
  * ['Domain.Entities.Fiscalization.FiscalReceiptStage']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Fiscalization.FiscalReceiptStage']?: Record<string, string>


  /**
  * ['Domain.Entities.Analytics.AnalyticsEventType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Analytics.AnalyticsEventType']?: Record<string, string>


  /**
  * ChannelFillRunKind
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ChannelFillRunKind?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.LoyaltyTierPeriodType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.LoyaltyTierPeriodType']?: Record<string, string>


  /**
  * ['Domain.Entities.Channels.PaymentMoment']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Channels.PaymentMoment']?: Record<string, string>


  /**
  * ['Domain.Entities.Channels.ChannelPlatform']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Channels.ChannelPlatform']?: Record<string, string>


  /**
  * ['Domain.Entities.Channels.PaymentAcquirer']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Channels.PaymentAcquirer']?: Record<string, string>


  /**
  * ['Domain.Entities.Analytics.MetrikaConversionStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Analytics.MetrikaConversionStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.Exchange.ExchangeStructureProvisioning']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Exchange.ExchangeStructureProvisioning']?: Record<string, string>


  /**
  * ['Domain.Entities.Analytics.MetrikaOfflineIdType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Analytics.MetrikaOfflineIdType']?: Record<string, string>


  /**
  * ProductChannelPresence
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ProductChannelPresence?: Record<string, string>


  /**
  * ['Web.Api.Controllers.ProductsTemplates.Models.TemplateProductVariantState']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Web.Api.Controllers.ProductsTemplates.Models.TemplateProductVariantState']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationShotType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationShotType']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.SmtpAuthMethod']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.SmtpAuthMethod']?: Record<string, string>


  /**
  * ContentItemChannelStatus
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ContentItemChannelStatus?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.PromotionRewardType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.PromotionRewardType']?: Record<string, string>


  /**
  * ['Domain.Entities.Channels.DeliveryMethodKind']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Channels.DeliveryMethodKind']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.SmtpSecurity']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.SmtpSecurity']?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.NPlusMFreeItemPolicy']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.NPlusMFreeItemPolicy']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationBatchStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationBatchStatus']?: Record<string, string>


  /**
  * ['Web.Api.Controllers.Orders.Models.OrderCompleteRequestAction']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Web.Api.Controllers.Orders.Models.OrderCompleteRequestAction']?: Record<string, string>


  /**
  * ['Services.Marketplaces.MarketplaceSyncStream']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Services.Marketplaces.MarketplaceSyncStream']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.TaxationType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.TaxationType']?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.OrderItemCancelledReason']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.OrderItemCancelledReason']?: Record<string, string>


  /**
  * ['Domain.Entities.Analytics.SalesStage']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Analytics.SalesStage']?: Record<string, string>


  /**
  * ['Domain.Entities.Exchange.ExchangeStockOwnership']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Exchange.ExchangeStockOwnership']?: Record<string, string>


  /**
  * ['Domain.Entities.Exchange.ExchangeCatalogOwnership']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Exchange.ExchangeCatalogOwnership']?: Record<string, string>


  /**
  * ['Domain.Entities.Notifications.ImageGenerationBatchNotificationReason']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.ImageGenerationBatchNotificationReason']?: Record<string, string>


  /**
  * ['Domain.Entities.Products.LayeredValueSource']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Products.LayeredValueSource']?: Record<string, string>


  /**
  * ChannelFillItemStatus
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ChannelFillItemStatus?: Record<string, string>


  /**
  * ['Domain.Entities.Notifications.NotificationType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.NotificationType']?: Record<string, string>


  /**
  * ProductChannelStatus
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ProductChannelStatus?: Record<string, string>


  /**
  * ['Domain.Entities.Fiscalization.FiscalReceiptAttemptStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Fiscalization.FiscalReceiptAttemptStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.Crm.CrmBroadcastStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Crm.CrmBroadcastStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationVerificationMode']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationVerificationMode']?: Record<string, string>


  /**
  * ['Domain.Entities.Channels.ChannelExternalStockMode']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Channels.ChannelExternalStockMode']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.YandexPayReceiptVia']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.YandexPayReceiptVia']?: Record<string, string>


  /**
  * ['Domain.Entities.PageBlocks.PageBlockCtaTargetType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.PageBlocks.PageBlockCtaTargetType']?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.OrderStatusPublic']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.OrderStatusPublic']?: Record<string, string>


  /**
  * ['Domain.Entities.Marketplaces.ChannelSyncRunStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Marketplaces.ChannelSyncRunStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.GiftReturnPolicy']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.GiftReturnPolicy']?: Record<string, string>


  /**
  * ['Domain.Entities.Notifications.NotificationProductSource']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.NotificationProductSource']?: Record<string, string>


  /**
  * ContentStatus
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ContentStatus?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.FfdVersion']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.FfdVersion']?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.LoyaltyAccrualTrigger']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.LoyaltyAccrualTrigger']?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.LoyaltyLotStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.LoyaltyLotStatus']?: Record<string, string>


  /**
  * ['Web.Api.Controllers.PageBlocks.Models.PageBlockReadiness']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Web.Api.Controllers.PageBlocks.Models.PageBlockReadiness']?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.OrderCancelledReason']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.OrderCancelledReason']?: Record<string, string>


  /**
  * ['Domain.Entities.Analytics.MetrikaGoal']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Analytics.MetrikaGoal']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.SellerAiProvider']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.SellerAiProvider']?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.DiscountSource']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.DiscountSource']?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.LoyaltyAccrualBase']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.LoyaltyAccrualBase']?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.OrderItemStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.OrderItemStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.PromotionConditionType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.PromotionConditionType']?: Record<string, string>


  /**
  * ['Domain.Entities.Marketplaces.MarketplaceSyncOutboxKind']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Marketplaces.MarketplaceSyncOutboxKind']?: Record<string, string>


  /**
  * ['Domain.Entities.Notifications.NotificationTargetDeliveryChannel']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.NotificationTargetDeliveryChannel']?: Record<string, string>


  /**
  * ChannelFillRunState
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ChannelFillRunState?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.PaymentGatewayKind']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.PaymentGatewayKind']?: Record<string, string>


  /**
  * ['Web.Api.Controllers.Orders.Models.OrderProgressRequestAction']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Web.Api.Controllers.Orders.Models.OrderProgressRequestAction']?: Record<string, string>


  /**
  * ['Domain.Entities.PageBlocks.PageBlockSlideMediaKind']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.PageBlocks.PageBlockSlideMediaKind']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.SmtpSaslMechanism']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.SmtpSaslMechanism']?: Record<string, string>


  /**
  * ['Domain.Entities.Marketplaces.MarketplaceKind']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Marketplaces.MarketplaceKind']?: Record<string, string>


  /**
  * ExchangeOrderOps
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ExchangeOrderOps?: Record<string, string>


  /**
  * CategoryMirrorItemStatus
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  CategoryMirrorItemStatus?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationBatchScope']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationBatchScope']?: Record<string, string>


  /**
  * ContentType
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ContentType?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.CapReductionPolicy']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.CapReductionPolicy']?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.PaymentReceiptSource']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.PaymentReceiptSource']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationTaskPriority']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationTaskPriority']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationCandidateVerdict']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationCandidateVerdict']?: Record<string, string>


  /**
  * ['Domain.Entities.Analytics.DynamicsGranularity']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Analytics.DynamicsGranularity']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationTaskStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationTaskStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.LoyaltyLotKind']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.LoyaltyLotKind']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationMode']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationMode']?: Record<string, string>


  /**
  * ['Domain.Entities.Channels.ChannelExternalPriceMode']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Channels.ChannelExternalPriceMode']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationCandidateDecision']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationCandidateDecision']?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.LoyaltyPendingAccrualStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.LoyaltyPendingAccrualStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.TinkoffReceiptPaymentObject']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.TinkoffReceiptPaymentObject']?: Record<string, string>


  /**
  * ['Domain.Entities.Marketplaces.MarketplaceSyncOutboxStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Marketplaces.MarketplaceSyncOutboxStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.PageBlocks.PageBlockTextAlignment']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.PageBlocks.PageBlockTextAlignment']?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.OrderStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.OrderStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.Exchange.ExchangeSourceDeletePolicy']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Exchange.ExchangeSourceDeletePolicy']?: Record<string, string>


  /**
  * ExternalRefMappingState
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ExternalRefMappingState?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.LoyaltyTransactionType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.LoyaltyTransactionType']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageStylePresetOrigin']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageStylePresetOrigin']?: Record<string, string>


  /**
  * ['Infrastructure.SDEK.Dto.Enums.SDEKOfficeType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Infrastructure.SDEK.Dto.Enums.SDEKOfficeType']?: Record<string, string>


  /**
  * ['Domain.Entities.Notifications.NotificationProductSubject']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Notifications.NotificationProductSubject']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.TinkoffReceiptTax']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.TinkoffReceiptTax']?: Record<string, string>


  /**
  * ['Domain.Entities.Channels.TelegramBotUpdateMode']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Channels.TelegramBotUpdateMode']?: Record<string, string>


  /**
  * ApiKeyScope
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ApiKeyScope?: Record<string, string>


  /**
  * ['Domain.Entities.Cdek.CdekCounterpartyType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Cdek.CdekCounterpartyType']?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.PromotionSelectionPolicy']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.PromotionSelectionPolicy']?: Record<string, string>


  /**
  * Gender
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  Gender?: Record<string, string>


  /**
  * ['Domain.Entities.Orders.OrderCashbackAccrualStatus']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Orders.OrderCashbackAccrualStatus']?: Record<string, string>


  /**
  * ['Domain.Entities.PageBlocks.PageBlockType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.PageBlocks.PageBlockType']?: Record<string, string>


  /**
  * ['Domain.Entities.Marketplaces.ChannelSyncRunType']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Marketplaces.ChannelSyncRunType']?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.DiscountCapScope']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.DiscountCapScope']?: Record<string, string>


  /**
  * ['Domain.Entities.Loyalty.PromoBonusCampaignTrigger']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Loyalty.PromoBonusCampaignTrigger']?: Record<string, string>


  /**
  * ['Domain.Entities.Sellers.FiscalProvider']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Sellers.FiscalProvider']?: Record<string, string>


  /**
  * ['Domain.Entities.Promotions.RewardScope']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Promotions.RewardScope']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.HumanModelConsistency']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.HumanModelConsistency']?: Record<string, string>


  /**
  * ['Services.Notifications.Templates.NotificationTemplatePlaceholderKind']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Services.Notifications.Templates.NotificationTemplatePlaceholderKind']?: Record<string, string>


  /**
  * ['Domain.Entities.ImageGeneration.ImageGenerationStyleMode']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.ImageGeneration.ImageGenerationStyleMode']?: Record<string, string>


  /**
  * ['Domain.Entities.Exchange.ExchangeVariantGrouping']
  * Словарь актуальных значений  *   * * ключи - возможные значения перечислимого типа  * * значения - строки, пригодные для показа пользователю  */
  @ActiveField(() => undefined)
  ['Domain.Entities.Exchange.ExchangeVariantGrouping']?: Record<string, string>
}
